var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    fill: "currentcolor",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.838 8.695l3.388 3.426-1.616 1.662-.354.322-.499.51-6.751 6.792-.68.685-4.552 1.213 1.201-4.603 1.213-1.28 6.182-6.235 2.468-2.492zm-8.65 10.444l-.144.163-.6 2.287 2.264-.607.162-.163-1.682-1.68zm7.029-7.096l-6.182 6.24 1.688 1.699 6.187-6.199-1.693-1.74zm1.621-1.632l-.768.776 1.687 1.71.77-.782-1.689-1.704z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.3ea6906d.svg";
export { ForwardRef as ReactComponent };